module.exports = __webpack_public_path__ + "img/goods-right.3e35bdc3.png";